export default __webpack_public_path__ + "static/media/User-Warning-Mobile.5c1c7688.svg";